import { required, email } from 'utils/validation'

export default function(values) {
  return {
    email: required(values.email) || email(values.email)
  }
}
